import React from "react";
import queryString from "query-string";
import { Form, Progress, Alert } from "reactstrap";

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from "./img/logo.png"
import enter from "./img/enter.png"

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = "per_py";
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: "",
      },
      username: "",
      password: "",
      showPassword: false,
    };
  }

  componentDidMount() {
    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message,
      },
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: "",
      },
    });



    this.props.api
      .userPassLogin(
        {
          username: this.usernameInput.value,
          password: this.passwordInput.value.replace(/[\u00A0-\u9999<>&]/g, (i) => '&#' + i.charCodeAt(0) + ';'),
        },
        this.parameters
      )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location =
          this.parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const translate = this.props.translate(error.errorCode);

        let message = this.props.translate('RequestLoginErrorMessage');

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }
        this.setState({
          onLogin: false,
          error: { open: true, message: message },
        });
      });
  }

  render() {
    const { translate } = this.props;

    return (
      <>
        <Form onSubmit={(event) => this.onSubmit(event)} className="login">
          <div className="wrapper fadeInDown">
            <div id="snackbar"></div>
            <div id="formContent">
              <div className="menu1">
                <div className="fadeIn first">
                  <img src={logo} id="icon" alt="Personal Icon" />
                </div>
                <input
                  className="fadeIn second"
                  disabled={this.state.onLogin}
                  placeholder={translate("PlaceholderUserName")}
                  ref={(ref) => {
                    this.usernameInput = ref;
                  }}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  name="login"
                  id="login"
                />
                <div>
                  <input
                    className="fadeIn third"
                    required={true}
                    disabled={this.state.onLogin}
                    placeholder={translate("PlaceholderPassword")}
                    ref={(ref) => {
                      this.passwordInput = ref;
                    }}

                    tabIndex={1}
                    type={this.state.showPassword ? "text" : "password"}
                    autoCorrect="off"
                    autoCapitalize="none"
                    id="password"
                    name="login"
                  >
                  </input>
                  <button type="button" onClick={() => this.setState({ showPassword: !this.state.showPassword })} className="personalHidePassword">
                    <i class="fa fa-eye"></i>
                  </button>
                </div>
                <div className="buttons">
                  {!this.state.onLogin ? (
                    <button type="submit" className="fadeIn fourth" id="entrar" disabled={!this.props.turnstileSuccess}>
                      <span className="entrar-text" id="text">
                        <img src={enter} alt="enter icon" id="entrar-icon" />
                        {translate("ButtonEnter")}
                      </span>
                    </button>
                  ) : (
                    <Progress animated color="danger" value={100} />
                  )}
                  <a href="https://www.personal.com.py/ott/forgotPass.html" class="link" id="link">¿Olvidaste tu contraseña?</a><br></br>
                  <a href="https://www.personal.com.py/ott/home.html" class="link" id="link2"> Crear una cuenta</a>
                </div>
                <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
                <div className="messages-container">
                  <Alert
                    color="danger"
                    id="error-message"
                    isOpen={this.state.error.open}
                    toggle={() => this.setState({ error: { open: false } })}
                  >
                    {this.state.error.message}
                  </Alert>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
